import Sidebar from "./Sidebar";
import Header from "./Header";

const Layout = ({ children }) => (
    <div className="flex min-h-screen overflow-x-hidden">
        <Sidebar />
        <div className="flex-1 flex flex-col ml-64 min-w-0">
            <Header />
            <main className="flex-1 bg-[var(--bg-light)] p-0.5 pr-0 overflow-y-auto overflow-x-hidden mt-16 max-w-full">{children}</main>
        </div>
    </div>
);

export default Layout; 